export enum LabelTheme {
  DEFAULT = "default",
  EXCHANGE_BACK = "exchange_back",
  EXCHANGE_LAY = "exchange_lay",
  LOADING = "loading",
  DISABLED = "disabled",
}

export enum BetSegmentsColor {
  Blue = "BLUE",
  Teal = "TEAL",
  Pink = "PINK",
}

export enum BetSegmentsSize {
  SMALL = "small",
  LARGE = "large",
}

export enum BetSegmentsIcons {
  ODDSBOOST = "ODDSBOOST",
  SUPER_BOOST = "SUPER_BOOST",
  DOUBLE_UP_BOOST = "DOUBLE_UP_BOOST",
}

export type BetSegmentsLabelsProps = {
  /** Label text for the left segment */
  leftLabel?: string;
  /** Label text for the middle segment */
  midLabel?: string;
  /** Label text for the middle-right segment */
  midRightLabel?: string;
  /** Label text for the right segment */
  rightLabel?: string;
};

export type BetSegmentsValuesProps = {
  /** Value displayed in the left segment */
  leftValue?: string;
  /** Previous value for the left segment, shown when value changes */
  leftPreviousValue?: string;
  /** Value displayed in the middle segment */
  midValue?: string;
  /** Additional detail text for the middle segment value */
  midValueDetail?: string;
  /** Value displayed in the middle-right segment */
  midRightValue?: string;
  /** Previous value for the middle-right segment, shown when value changes */
  midRightPreviousValue?: string;
  /** Raw numerical value for the middle-right segment */
  midRightRawValue?: number;
  /** Additional detail text for the middle-right segment value */
  midRightValueDetail?: string;
  /** Value displayed in the right segment */
  rightValue?: string;
  /** Raw numerical value for the right segment */
  rightRawValue?: number;
  /** Previous value for the right segment, shown when value changes */
  rightPreviousValue?: string;
  /** Icon to display within the segments */
  icon?: BetSegmentsIcons;
  /** Color indicator dot to display */
  colorIndicator?: BetSegmentsColor;
  /** Size variant of the segments. @default BetSegmentsSize.LARGE */
  size?: BetSegmentsSize;
  /** Theme for the side label */
  sideTheme?: LabelTheme;
  /** Text for an additional side label */
  sideLabel?: string;
  /** Whether the odds have been boosted, affects styling */
  isOddsBoosted?: boolean;
  /** Whether the left segment displays odds values. @default true */
  isLeftSegmentOdds?: boolean;
  /** Whether the middle segment displays odds values. @default true */
  isMiddleSegmentOdds?: boolean;
  /** Whether the middle-right segment displays odds values. @default true */
  isMiddleRightSegmentOdds?: boolean;
  /** Whether the right segment displays odds values. @default false */
  isRightSegmentOdds?: boolean;
};

export type BetSegmentsProps = BetSegmentsValuesProps & BetSegmentsLabelsProps;
